// src/components/card/pdfCard/PdfBackground.jsx
import React, {useState} from "react";
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;


const PdfBackground = ({ pdfFile, onLoadComplete }) => {
  const [numPages, setNumPages] = useState(null);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    if (onLoadComplete) {
      onLoadComplete();
    }
  }

  function onDocumentLoadError(error) {
    console.error('Error loading PDF:', error);
    if (onLoadComplete) {
      onLoadComplete();
    }
  }

    return (
    <div className="blur-[1px]">
      <Document 
        file={pdfFile}
        onLoadSuccess={onDocumentLoadSuccess}
        onLoadError={onDocumentLoadError}
        loading={null}
      >
        <Page 
          pageNumber={1} 
          width={230}
          loading={null}
        /> 
      </Document>
    </div>
    );
};

export default PdfBackground;